import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import React, { useContext, useMemo } from "react";
import Skeleton from "@mui/material/Skeleton";

import Box from "@mui/material/Box";

import { FilterContext } from "../../contexts/FilterContext";
import { ApiDataContext } from "../../contexts/ApiDataContext";
import { useFilteredProjects } from "../../hooks/api/homeApiHooks";

import FilterResultSummary from "./FilterResultSummary";

export default function FilterResult() {
  const [
    selectedProgress,
    setSelectedProgress,
    selectedStages,
    setSelectedStages,
    selectedPDCs,
    setSelectedPDCs,
    selectedIntegrators,
    setSelectedIntegrators,
    selectedStates,
    setSelectedStates,
  ] = useContext(FilterContext);

  const { apiData } = useContext(ApiDataContext);

  // OTIMIZAÇÃO: Se todas as etapas estão selecionadas, não envia filtro (muito mais rápido)
  const parsedSelectedStages = useMemo(() => {
    // Se nenhuma etapa selecionada OU todas selecionadas = não filtra
    if (selectedStages.length === 0 || 
        (apiData.stages && selectedStages.length === apiData.stages.length)) {
      return "";
    }
    return selectedStages.map((selectedStage) => selectedStage.id).toString();
  }, [selectedStages, apiData.stages]);

  const pdcIds = useMemo(
    () => selectedPDCs?.map((pdc) => pdc.id),
    [selectedPDCs]
  );

  const clientIds = useMemo(
    () => selectedIntegrators?.map((client) => client.id),
    [selectedIntegrators]
  );

  const stateIds = useMemo(
    () => selectedStates?.map((state) => state.id),
    [selectedStates]
  );

  const { filteredProjectsLoading, filteredProjectsData } = useFilteredProjects(
    parsedSelectedStages,
    selectedProgress,
    pdcIds,
    clientIds,
    stateIds
  );

  // Skeleton Loader
  const SkeletonLoader = () => (
    <Box sx={{ width: "100%" }}>
      {[1, 2, 3].map((item) => (
        <Box key={item} sx={{ mb: 2, p: 2, backgroundColor: "#F9FAFB", borderRadius: 1 }}>
          <Box sx={{ display: "flex", gap: 2, mb: 1 }}>
            <Skeleton variant="text" width={100} height={24} />
            <Skeleton variant="text" width={200} height={24} />
            <Skeleton variant="text" width={150} height={24} />
          </Box>
          <Box sx={{ display: "flex", gap: 2 }}>
            <Skeleton variant="text" width={120} height={20} />
            <Skeleton variant="text" width={180} height={20} />
            <Skeleton variant="text" width={100} height={20} />
          </Box>
        </Box>
      ))}
    </Box>
  );

  return (
    <Box
      sx={{
        backgroundColor: "#FFFFFF",
        borderRadius: 2,
        boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
        p: 3,
        minHeight: 400,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          fontSize: "1.125rem",
          color: "#1F2937",
          mb: 3,
        }}
      >
        Projetos {selectedProgress === undefined ? "" : selectedProgress.name}
      </Typography>

      {filteredProjectsLoading ? (
        <SkeletonLoader />
      ) : (
        <React.Fragment>
          {filteredProjectsData && filteredProjectsData.length > 0 ? (
            filteredProjectsData.map((filteredProject, index) => {
              return (
                <FilterResultSummary
                  key={filteredProject.id}
                  index={index}
                  project={filteredProject}
                />
              );
            })
          ) : (
            <Box
              sx={{
                textAlign: "center",
                py: 8,
                color: "text.secondary",
              }}
            >
              <Typography variant="body1" color="text.secondary">
                Nenhum projeto encontrado com os filtros selecionados
              </Typography>
            </Box>
          )}
        </React.Fragment>
      )}
    </Box>
  );
}
